import { ReactElement, ReactNode } from 'react';
import { AdvanceSearchModalContext } from './AdvanceSearchModal.context';
import useAdvanceSearchModal from './AdvanceSearchModal.hook';

export default function AdvanceSearchModalProvider(props: {
  children: ReactNode;
}): ReactElement {
  const { children } = props;
  const advanceSearchModal = useAdvanceSearchModal();

  return (
    <AdvanceSearchModalContext.Provider value={advanceSearchModal}>
      {children}
    </AdvanceSearchModalContext.Provider>
  );
}
